import { useMemo } from "react";
import { useStringTranslation } from "../../../common/hooks/useStringTranslation";

export const useThankYouLabels = (): Record<string, string> => {
    const { t } = useStringTranslation();

    return useMemo(
        () => ({
            backToB2b: t("checkout-thank-you-back-to-b2b"),
            goBackToB2b: t("checkout-thank-you-go-back-to-b2b"),
            title: t("checkout-thank-you-title"),
            itemsInOrder: t("checkout-thank-you-items-title"),
            whatsNext: t("checkout-thank-you-whats-next"),
            step1Title: t("checkout-thank-you-step1-title"),
            step1Description: t("checkout-thank-you-step1-description"),
            step2Title: t("checkout-thank-you-step2-title"),
            step2Description: t("checkout-thank-you-step2-description"),
            step3Title: t("checkout-thank-you-step3-title"),
            step3Description: t("checkout-thank-you-step3-description"),
            priceLabel: t("checkout-thank-you-price-label"),
            serialNrLabel: "Serial Nr",
            artNrLabel: "Art Nr",
            refurbishedStatus: t("refurbished"),
        }),
        [t],
    );
};
